// Abonent kontakti — SO'ROV QURUVCHI. Forma bu yerga qaraydi, aksincha emas.
//
// =====================================================================
// ⚠️ NEGA ALOHIDA MODUL VA NEGA SOF (axios YO'Q, i18n YO'Q)
// =====================================================================
// Backendda abonent + kontakt zanjiri AYNI PAYTDA yozilyapti va sim
// shakli hali qat'iy emas: kontakt abonent tanasining ichiga kiradimi,
// yoki abonentga bog'langan yo'l bilan yuboriladimi — qaror bu panelniki
// EMAS. Shuning uchun forma va tekshiruvlar shakldan MUSTAQIL:
//
//   · `contactFields()` — maydonlarni tozalaydi va tashlaydi. Shakl
//     qanday bo'lishidan qat'i nazar o'zgarmaydi.
//   · `contactRequest()` — YAGONA joy, sim shakli aniq bo'lganda faqat
//     shu funksiyaning ikkita `return` i o'zgaradi.
//
// ⚠️ Bu qatlam serverning tekshiruvini TAKRORLAMAYDI, undan OLDIN
// keladi: `ContactFields` (xsib-platform) bo'sh satrni `null` ga
// aylantiradi va butunlay bo'sh kontaktni 400 bilan rad etadi. Panel
// o'sha 400 ni chiqarmasligi kerak — u operatorga hech narsa
// tushuntirmaydi.

import { normalizePhone } from './subscriberApi'

/** `ContactFields` dagi cheklovlarning AYNAN o'zi (xsib-platform) */
export const CONTACT_LIMITS = {
  fullName: 160,
  email: 190,
  address: 240,
  note: 500,
} as const

/**
 * ⚠️ E.164 EMAS va bo'lmaydi (egasi qarori): tizim Afg'onistonda ham
 * ishlaydi va mamlakat kodisiz kiritilgan raqam rad etilmasligi kerak.
 * Chegara `ContactPhoneRule` dan — faqat uzunlik va xavfli belgi.
 */
export const CONTACT_PHONE_MIN = 4
export const CONTACT_PHONE_MAX = 32

/** `ContactPhoneRule.DANGEROUS` — panel va eksportga zarar beradigan belgilar */
export const CONTACT_PHONE_FORBIDDEN = /[<>&";'\\]|\p{Cc}/u

/**
 * ⚠️ Naqsh ATAYLAB sodda — `ContactFields.requireEmailShape` bilan bir
 * xil. To'liq RFC 5322 haqiqiy manzillarni ham rad etadi va operator
 * sababni tushunmasdi.
 */
export const CONTACT_EMAIL_SHAPE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export interface ContactValues {
  fullName?: string
  phone?: string
  phoneAlt?: string
  email?: string
  regionId?: string
  districtId?: string
  address?: string
  note?: string
}

/**
 * Serverga ketadigan maydonlar.
 *
 * ⚠️ `region` / `district` ERKIN MATN maydonlari BU YERDA YO'Q va
 * qo'shilmaydi. Egasining qarori (SHARTNOMA-4 §A3): viloyat va tuman
 * alohida CRUD bo'lib, formadan faqat TANLANADI. Erkin matn yozilsa
 * bitta viloyat bazada besh xil imloda yotardi va hisobotlar uni besh
 * boshqa hudud deb sanardi.
 */
export interface ContactFields {
  fullName?: string
  phone?: string
  phoneAlt?: string
  email?: string
  regionId?: string
  districtId?: string
  address?: string
  note?: string
}

/**
 * Niqoblangan raqam (`+9989****567`).
 *
 * ⚠️ `ContactEntry.masked()` har O'QISH yo'lida qo'llanadi, ya'ni
 * `contact.reveal` siz kelgan raqam HAR DOIM niqobli. Uni forma orqali
 * qaytarib yuborish raqamni yulduzchalar bilan BOSIB YOZARDI va bu
 * hech qanday xato bermasdi — SMS faqat keyingi safar bormay qolardi.
 */
export function isMaskedValue(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.includes('*')
}

function text(raw: string | undefined): string | undefined {
  const trimmed = raw?.trim()
  return trimmed ? trimmed : undefined
}

function phone(raw: string | undefined): string | undefined {
  const normalized = normalizePhone(raw)
  return normalized === null ? undefined : normalized
}

/**
 * Formadagi qiymatlarni serverning maydonlariga aylantiradi.
 *
 * `null` — kontakt UMUMAN yo'q (hamma maydon bo'sh). Bu «bo'sh kontakt
 * yubor» degani emas: `ContactFields` bunday tanani 400 bilan rad etadi,
 * chunki bo'sh yozuv `contact_owner_uq` orqali EGANI band qilib qo'yardi
 * va keyingi haqiqiy kontakt 409 olardi.
 */
export function contactFields(values: ContactValues): ContactFields | null {
  const fullName = text(values.fullName)
  const main = phone(values.phone)
  const alt = phone(values.phoneAlt)
  const email = text(values.email)
  const address = text(values.address)
  const note = text(values.note)
  const regionId = text(values.regionId)

  /*
    ⚠️ TUMAN VILOYATSIZ KETMAYDI — ikkinchi qatlam.

    Birinchi qatlam formada: viloyat o'zgarganda tuman tozalanadi. U
    yetarli emas, chunki holat boshqa yo'l bilan ham buzilishi mumkin
    (viloyat `allowClear` bilan bo'shatiladi, eski qiymat qayta
    yuklanadi). Nomuvofiq juftlikni server kompozit FK bilan rad etadi
    va operator sababi ko'rinmaydigan xato oladi.
  */
  const districtId = regionId === undefined ? undefined : text(values.districtId)

  /*
    ⚠️ NIQOBLANGAN QIYMAT HECH QACHON YUBORILMAYDI.

    Forma niqobli raqamni tahrirlashga bermaydi, lekin bu tekshiruv
    o'sha qarordan MUSTAQIL: qaytarib yuborilgan `+9989****567` bazadagi
    haqiqiy raqamni jimgina yo'q qilardi.
  */
  const safeMain = isMaskedValue(main) ? undefined : main
  const safeAlt = isMaskedValue(alt) ? undefined : alt

  /*
    ⚠️ `contact_phone_alt_needs_phone` ning aksi: yolg'iz ikkinchi raqam
    saqlanib qolsa, «raqami yo'q kontaktlar» so'rovi (`phone IS NULL`)
    bunday qatorni RAQAMSIZ deb sanardi. Server buni 400 bilan rad
    etadi; forma esa buni maydon yonida aytadi.
  */
  const keptAlt = safeMain === undefined ? undefined : safeAlt

  const fields: ContactFields = {
    ...(fullName === undefined ? {} : { fullName }),
    ...(safeMain === undefined ? {} : { phone: safeMain }),
    ...(keptAlt === undefined ? {} : { phoneAlt: keptAlt }),
    ...(email === undefined ? {} : { email }),
    ...(regionId === undefined ? {} : { regionId }),
    ...(districtId === undefined ? {} : { districtId }),
    ...(address === undefined ? {} : { address }),
    ...(note === undefined ? {} : { note }),
  }

  return Object.keys(fields).length === 0 ? null : fields
}

/**
 * Mavjud kontakt haqida formaga kerak bo'lgan YAGONA narsa.
 *
 * `null` — kontakt yo'q YOKI ko'rinmadi (huquq yetmadi). Ikkalasi bir
 * xil ishlanadi va bu ataylab: ikkalasida ham panel bazada nima
 * turganini BILMAYDI, ya'ni bo'sh maydonni «o'chirildi» deb yuborishga
 * haqqi yo'q.
 */
export interface ExistingContact {
  id: string
  /**
   * Tahrirlab bo'lmaydi — o'qilgan qiymatlar niqobli. To'liq raqamsiz
   * `PUT` (u TO'LIQ ALMASHTIRISH) raqamni yo'q qilardi.
   */
  locked: boolean
}

export interface ContactRequestInput {
  subscriberId: string
  values: ContactValues
  existing: ExistingContact | null
}

/** Bajarilishi kerak bo'lgan so'rov — `subscriberApi.sendContact` uni yuboradi */
export interface ContactRequest {
  method: 'post' | 'put'
  path: string
  body: Record<string, unknown>
}

/**
 * ⚠️ SIM SHAKLI SHU YERDA VA FAQAT SHU YERDA.
 *
 * O'lchangan kontrakt (`SubscriberContactResource`):
 *   PUT /api/subscribers/{id}/contact   {...fields}  -> 200
 *
 * ⛔ `/api/contacts` BU YERDAN CHAQIRILMAYDI. U XODIMLAR API'si va
 * `contact.write` ni BUTUN TENANT doirasida talab qiladi
 * (`TenantWideGuard.require` — `platform.contact` da tashkiliy egalik
 * ustuni yo'q). Sherikda na bu huquq bor, na tenant-keng doira, ya'ni
 * chaqiruv 403 beradi va abonent kontaktsiz qolib ketardi
 * («Abonent saqlandi, LEKIN kontakt saqlanmadi», o'lchandi 2026-08-23).
 *
 * ⚠️ Huquqni sherikka QO'SHIB qo'yish yechim EMAS: tenant-keng
 * `contact.write` unga XODIMLARNING va tashkilot birliklarining
 * kontaktini ham ochib berardi. Abonentga bog'langan yo'l esa doirani
 * o'zi tekshiradi (`requireInScope`) va begona abonentga yo'l bermaydi.
 *
 * Sim shakli o'zgarsa — quyidagi bitta `return`. Forma, tekshiruvlar va
 * `contactFields()` TEGILMAYDI.
 *
 * `null` — hech narsa yubormaslik kerak:
 *   · yangi kontakt, lekin maydonlar bo'sh — yuborishga narsa yo'q;
 *   · mavjud kontakt niqobli (`locked`) — tahrir umuman ochilmagan;
 *   · mavjud kontakt bor, lekin forma butunlay bo'shatilgan.
 *
 * ⚠️ Oxirgisi eng muhimi: `PUT` TO'LIQ ALMASHTIRISH va bo'sh tanani
 * yuborish butun kontaktni o'chirardi. «Foydalanuvchi hech narsa
 * kiritmadi» bilan «foydalanuvchi hammasini o'chirmoqchi» ni JSON
 * ajratmaydi, shuning uchun panel xavfsiz tomonni tanlaydi.
 */
export function contactRequest(input: ContactRequestInput): ContactRequest | null {
  const fields = contactFields(input.values)
  if (fields === null) return null

  // ⚠️ Yagona yo'l: `save` serverda yaratish va tahrirlashni O'ZI
  // ajratadi (`ContactLinkService#save`), ya'ni panelda `existing`
  // bo'yicha shoxlanishning endi ma'nosi yo'q. `locked` esa qoladi —
  // niqobli kontaktni yuborish to'liq almashtirishda haqiqiy raqamni
  // yulduzchalar bilan almashtirib qo'yardi.
  if (input.existing !== null && input.existing.locked) return null
  return {
    method: 'put',
    path: `/api/subscribers/${input.subscriberId}/contact`,
    body: { ...fields },
  }
}
